import { render, staticRenderFns } from "./searchList.vue?vue&type=template&id=1c4c96b6&scoped=true"
import script from "./searchList.vue?vue&type=script&lang=js"
export * from "./searchList.vue?vue&type=script&lang=js"
import style0 from "./searchList.vue?vue&type=style&index=0&id=1c4c96b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c96b6",
  null
  
)

export default component.exports